import { Text } from '@vouched.id/vault';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { AAMVADropdowns } from './AAMVA/AAMVADropdowns';
import { CrossCheckDropdowns } from './CrossCheck/CrossCheckDropdowns';
import { DOBDropdowns } from './DOB/DOBDropdowns';
import { DeleteDropdown } from './Delete/DeleteDropdown';
import { IDVDropdowns } from './IDV/IDVDropdowns';
import { ReverificationDropdowns } from './Reverification/ReverificationDropdowns';
import { ECBSVDropdowns } from './SSN/ECBSV/ECBSVDropdowns';
import { PrivateSSNDropdowns } from './SSN/PrivateSSN/PrivateSSNDropdowns';
import { SelfieVerificationDropdowns } from './SelfieVerification/SelfieVerificationDropdowns';
import { TinValidationDropdown } from './TinValidation/TinValidationDropdown';
import { useJobSectionTitleStyles } from './utils';
import { JobType } from 'components/account/jobs/job_type';
import { AmlPageSwitch } from 'components/account/jobs-v2/dropdowns/AML/AmlPageSwitch';
import { ACCOUNT_ADMIN_PERMISSIONS, DOWNLOADER_PERMISSIONS, isAuthorized } from 'security/authorization';
import { useGlobalState } from 'store/reducers/reducer';
export const JobResultDropdowns = ({ job, jobErrors, jobRequestInfo, jobRequestParams, jobRequestProperties, jobSid, jobStatus, jobDebugResults, jobResult, jobType, crossCheckResult, rejectionReasons, jobReview, onReviewSubmitted }) => {
    const { user } = useGlobalState().state;
    const isAdminRoute = useLocation().pathname.includes('/admin');
    const jobSectionTitleStyles = useJobSectionTitleStyles();
    const filesDropdownVisible = !isAdminRoute && isAuthorized(user, DOWNLOADER_PERMISSIONS);
    const deleteDropdownVisible = !isAdminRoute && isAuthorized(user, ACCOUNT_ADMIN_PERMISSIONS);
    let crossCheckSubmittedAddress;
    if (jobRequestParams?.address) {
        const { address } = jobRequestParams;
        crossCheckSubmittedAddress = `${address.streetAddress} ${address.unit} ${address.city} ${address.state} ${address.postalCode} ${address.country}`;
    }
    const crossCheckSubmittedData = {
        firstName: `${jobResult?.firstName ?? jobRequestParams?.firstName ?? ''} ${jobResult?.middleName ?? jobRequestParams?.middleName ?? ''}`.trim(),
        lastName: jobResult?.lastName ?? jobRequestParams?.lastName,
        address: jobResult?.address ??
            jobResult?.unverifiedIdAddress ??
            crossCheckSubmittedAddress,
        email: jobRequestParams?.email,
        phone: jobRequestParams?.phone,
        ipAddress: jobRequestInfo?.ipaddress
    };
    const getDropdowns = (type) => {
        switch (type) {
            case JobType.idVerification:
                return (React.createElement(IDVDropdowns, { crossCheckResult: crossCheckResult, crossCheckSubmittedData: crossCheckSubmittedData, debugDropdownVisible: isAdminRoute, filesDropdownVisible: filesDropdownVisible, job: job, jobDebugResults: jobDebugResults, jobErrors: jobErrors, jobRequestInfo: jobRequestInfo, jobRequestParams: jobRequestParams, jobRequestProperties: jobRequestProperties, jobResult: jobResult, jobReview: jobReview, jobSid: jobSid, jobStatus: jobStatus, onReviewSubmitted: onReviewSubmitted, rejectionReasons: rejectionReasons }));
            case JobType.idReverification:
                return (React.createElement(ReverificationDropdowns, { debugDropdownVisible: isAdminRoute, filesDropdownVisible: filesDropdownVisible, jobDebugResults: jobDebugResults, jobErrors: jobErrors, jobRequestInfo: jobRequestInfo, jobRequestParams: jobRequestParams, jobResult: jobResult, jobReview: jobReview, jobSid: jobSid, jobStatus: jobStatus, onReviewSubmitted: onReviewSubmitted, rejectionReasons: rejectionReasons }));
            case JobType.selfieVerification:
                return (React.createElement(SelfieVerificationDropdowns, { debugDropdownVisible: isAdminRoute, jobDebugResults: jobDebugResults, jobErrors: jobErrors, jobRequestInfo: jobRequestInfo, jobRequestParams: jobRequestParams, jobRequestProperties: jobRequestProperties, jobResult: jobResult, jobReview: jobReview, jobSid: jobSid, jobStatus: jobStatus, onReviewSubmitted: onReviewSubmitted, rejectionReasons: rejectionReasons }));
            case JobType.ecbsvSSN:
                return React.createElement(ECBSVDropdowns, { jobSid: jobSid, parentJobStatus: jobStatus });
            case JobType.privateSSN:
                return (React.createElement(PrivateSSNDropdowns, { jobSid: jobSid, parentJobStatus: jobStatus }));
            case JobType.dob:
                return React.createElement(DOBDropdowns, { jobSid: jobSid, jobStatus: jobStatus });
            case JobType.idAml:
                return (React.createElement(AmlPageSwitch, { isAMLOnly: true, jobAMLResults: jobResult?.aml, jobErrors: jobErrors, jobSid: jobSid, jobStatus: jobStatus, jobType: jobType }));
            case JobType.idCrosscheck:
                return (React.createElement(CrossCheckDropdowns, { crossCheckResult: crossCheckResult, crossCheckSubmittedData: crossCheckSubmittedData, jobErrors: jobErrors, jobStatus: jobStatus }));
            case JobType.idAamva:
                return (React.createElement(AAMVADropdowns, { aamvaJobResult: jobResult?.aamva, country: jobResult?.country, jobSid: jobSid, jobStatus: jobStatus }));
            case JobType.tinValidation:
                return (React.createElement(TinValidationDropdown, { jobSid: jobSid, parentJobStatus: jobStatus }));
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Text, { style: jobSectionTitleStyles }, "Verifications"),
        getDropdowns(jobType),
        ![
            JobType.idVerification,
            JobType.selfieVerification,
            JobType.idReverification
        ].includes(jobType) &&
            deleteDropdownVisible && (React.createElement(Text, { style: jobSectionTitleStyles }, "Other")),
        deleteDropdownVisible && React.createElement(DeleteDropdown, null)));
};
